import _ from "lodash";
import moment from "moment";

class DocumentUtils {
    static unpackGroupToArray(grouped, datePart) {
        const groupArray = [];
        _.forEach(grouped, (data, groupName) => {
            const gnn = parseInt(groupName);
            const max = _.maxBy(data, d => moment(d.startDate)).startDate;
            groupArray.push({
                name: groupName,
                __display: groupName,
                __unit: datePart,
                __value: _.isNaN(gnn) ? null : gnn,
                __isGroup: true,
                data,
                startDate: max ? max : null,
            });
        });
        return _.reverse(_.sortBy(groupArray, "__value"));
    }

    static isGrouped(arr) {
        let isArray = false;
        for (let element of arr) {
            if (element.__isGroup) {
                isArray = true;
                break;
            }
        }
        return isArray;
    }

    static groupObjectByProperty(obj, propertyName) {
        return DocumentUtils.unpackGroupToArray(_.groupBy(obj, (data) => {
            if (!data[propertyName])
                return "";
            return data[propertyName];
        }), propertyName);
    }

    static groupObjectByDate(obj, propertyName, datePart) {
        if (DocumentUtils.isGrouped(obj)) {
            const arr = [];
            _.forEach(obj, data => {
                data.data = DocumentUtils.groupObjectByDate(data.data, propertyName, datePart);
                data.grouped = true;
                arr.push(data);
            });
            return arr;
        }
        return DocumentUtils.unpackGroupToArray(_.groupBy(obj, (data) => {
            if (!data[propertyName])
                return "";
            return moment(data[propertyName]).get(datePart);
        }), datePart);
    }

    static prepareStudies(studies, parent) {
        _.forEach(studies, study => {
            study.__key = "";
            if (parent)
                study.__key += parent.__key;
            study.__key += study.__display;

            if (study.__isGroup) {
                study.__parent = !!parent;
                DocumentUtils.prepareStudies(study.data, study);
            }
            if (study.__isStudy) {
                DocumentUtils.prepareDocuments(study.documents);
            }
        });
    }

    static prepareDocuments(documents) {
        let position = 1;
        _.forEach(documents, doc => {
            doc.__position = position;
            doc.metadata.sortOrder = position;
            position++;
        });
    }

    static expand(studies, studyToChange, expand) {
        _.forEach(studies, study => {
            if (study.__key === studyToChange.__key) {
                study.__expanded = expand;
            }
            if (study.__isGroup) {
                DocumentUtils.expand(study.data, studyToChange, expand);
            }
        });
    }

    static select(studies, studyToChange, selected) {
        _.forEach(studies, study => {
            if (study.__key === studyToChange.__key) {
                study.__selected = selected;
            }
            if (study.__isGroup) {
                DocumentUtils.select(study.data, studyToChange, selected);
            }
        });
    }

    static setDocumentError(studies, document, error) {
        _.forEach(studies, study => {
            if (study.__isStudy) {
                _.forEach(study.documents, documentLocal => {
                    if (documentLocal.__id === document.__id) {
                        documentLocal.__haveLoadError = error;
                    }
                });
            }
            if (study.__isGroup) {
                DocumentUtils.setDocumentError(study.data, document, error);
            }
        });
    }

    static enumStudy(studies, method) {
        let index = 0;
        _.forEach(studies, study => {
            if (study.__isStudy) {
                method(study);
            }
            if (study.__isGroup) {
                DocumentUtils.enumStudy(study.data, method);
            }
        });
    }

    static reorderStudyDocuments(studies, studyToChange, sourceIndex, destinationIndex) {
        for (const study of studies) {
            if (study.__key === studyToChange.__key) {
                const documents = Array.from(study.documents);
                const [removed] = documents.splice(sourceIndex, 1);
                documents.splice(destinationIndex, 0, removed);

                DocumentUtils.prepareDocuments(documents);

                study.documents = documents;

                return;
            }
            if (study.__isGroup) {
                DocumentUtils.reorderStudyDocuments(study.data, studyToChange, sourceIndex, destinationIndex);
            }
        }
    }

    static getStudy(studies, studyToFind) {
        for (const study of studies) {
            if (study.__key === studyToFind.__key) {
                return study;
            }
            if (study.__isGroup) {
                const res = DocumentUtils.getStudy(study.data, studyToFind);
                if (res) return res;
            }
        }
    }
}

export default DocumentUtils;
